import Animal from 'models/Animal';
import Base from 'models/Base';
import { toEntityList } from 'models/BaseList';

import {
  ANIMAL_ACTION_SUCCESS,
  ANIMAL_ACTION_CLEAR,
  ANIMAL_ASYNC_START,
  ANIMAL_ASYNC_STOP,
  ANIMAL_ASYNC_FAIL,
  ANIMAL_ASYNC_SUCCESS,
  ANIMAL_LIST_ASYNC_SUCCESS,
} from 'actions/animal';

const initialState = new Base({
  loading: false,
  errorMessage: '',
  data: new Animal(),
  list: toEntityList([], Animal),
});

const actionsMap = {
  [ANIMAL_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      data: new Animal(action.data),
    });
  },
  [ANIMAL_ACTION_CLEAR]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: '',
      data: {},
    });
  },
  [ANIMAL_ASYNC_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: '',
    });
  },
  [ANIMAL_ASYNC_STOP]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: '',
    });
  },
  [ANIMAL_ASYNC_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: new Animal(action.data),
    });
  },
  [ANIMAL_LIST_ASYNC_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      list: toEntityList(action.data, Animal),
    });
  },
  [ANIMAL_ASYNC_FAIL]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
};

export default function animal(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
